import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Projects from './pages/Projects';
import CertificationsPage from './pages/Certifications';
import LeadershipPage from './pages/Leadership';
import WorkPage from './pages/Work';
import HobbiesPage from './pages/Hobbies';
import Footer from './components/Footer';
import SkipLink from './components/SkipLink';
import PageMeta from './components/PageMeta';
import PlausibleAnalytics from './components/PlausibleAnalytics';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

function AppContent() {
  const location = useLocation();
  const activeSection = location.pathname === '/' ? 'home' : location.pathname.slice(1);

  return (
    <div className="App">
      <PageMeta />
      <PlausibleAnalytics />
      <SkipLink />
      <Navbar activeSection={activeSection} />
      <main id="main-content" className="app-main" tabIndex={-1}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/certifications" element={<CertificationsPage />} />
          <Route path="/leadership" element={<LeadershipPage />} />
          <Route path="/work" element={<WorkPage />} />
          <Route path="/affiliations" element={<Navigate to="/" replace />} />
          <Route path="/hobbies" element={<HobbiesPage />} />
          <Route path="/contact" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;

